import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';

const LeadsVinculados = ({
    leadsVinculados,
    setIdLead,
    setShowModalSeguimientoLead
}) => {
    if (leadsVinculados.length === 0) {
        return null;
    }

    return (
        <Col lg={12}>
            <Card>
                <Card.Header>
                    <Col>
                        <h5 className="mb-0">Leads</h5>
                    </Col>
                </Card.Header>

                <Card.Body className="border-top fs--1">
                    <div className="row">
                        {leadsVinculados.map((lead, index) => {
                            return (
                                <Col key={index} className="col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <div className="row ms-1">
                                        <Col className="col-12 m-0 p-0">
                                            <Link
                                                to={"#"}
                                                onClick={() => {
                                                    setIdLead(lead.idLead);
                                                    setShowModalSeguimientoLead(true);
                                                }}
                                            >
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip style={{ position: 'fixed' }}>
                                                            Ver informacion de este lead
                                                        </Tooltip>
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon="user"
                                                        transform="shrink-2"
                                                        className="ms-1"
                                                    />
                                                </OverlayTrigger>
                                                &nbsp;
                                                {"Lead #" + lead.idLead}
                                            </Link>
                                        </Col>
                                    </div>
                                    <div className="row ms-1">
                                        <Col className="col-12 m-0 p-0">
                                            <SoftBadge
                                                pill
                                                bg={
                                                    lead.idEtapa == 1 ? "secondary" :
                                                        lead.idEtapa == 2 ? "primary" :
                                                            lead.idEtapa == 3 ? "warning" :
                                                                lead.idEtapa == 4 ? "success" :
                                                                    lead.idEtapa == 5 ? "danger" :
                                                                        lead.idEtapa == 6 ? "warning" :
                                                                            lead.idEtapa == 7 ? "success" : "success"
                                                }
                                            >
                                                <span className="mb-0 fs--2 p-0">
                                                    {lead.vNombreEtapa}
                                                </span>
                                            </SoftBadge>
                                        </Col>
                                    </div>
                                    <div className="row ms-1">
                                        <Col className="col-12 m-0 p-0">
                                            <img src="/img/vendedor35.png" width={20} alt="Vendedor" /> {lead.vNombre}
                                        </Col>
                                    </div>
                                </Col>
                            )
                        })}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

LeadsVinculados.propTypes = {
    leadsVinculados: PropTypes.arrayOf(
        PropTypes.shape({
            idLead: PropTypes.number.isRequired,
            idEtapa: PropTypes.number,
            vNombreEtapa: PropTypes.string,
            vNombre: PropTypes.string
        })
    ).isRequired,
    setIdLead: PropTypes.func.isRequired,
    setShowModalSeguimientoLead: PropTypes.func.isRequired
};

export default LeadsVinculados;
